import React, { useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Button, Menu, Row, Col, Divider } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../../features/auth/apis/authSlice'

import { renderHomeTree } from '../../../config/HomeTree'
import Logout from '../../svgs/sider/Logout'
import Register from '../../../features/auth/components/Register'
import Login from '../../../features/auth/components/Login'
import NeedHelp from '../NeedHelp'
import Plus from '@/components/svgs/Plus'
import NewRequest from '@/components/shared-components/modals/request/NewRequest'
import useTranslation from '@/hooks/useTranslation'

export default function MenuContent({ setOpen }) {
  const dispatch = useDispatch()
  const router = useRouter()
  const { t } = useTranslation()

  const getMenuHref = (path) => {
    if (!path) {
      return '/'
    }

    return path.startsWith('/') ? path : `/${path}`
  }

  const { profile } = useSelector((state) => state.auth)

  const [registerOpen, setRegisterOpen] = useState(false)
  const [loginOpen, setLoginOpen] = useState(false)
  const [isNeedHelpOpen, setIsNeedHelpOpen] = useState(false)
  const [isNewRequestOpen, setIsNewRequestOpen] = useState(false)

  return (
    <>
      {!!profile && (
        <Button
          icon={<Plus style='w-full ltr:mr-8 rtl:ml-8' />}
          className='btn-green text-sm font-semibold rounded-lg py-16 w-11/12 mx-auto h-auto flex items-center justify-center mb-40'
          onClick={() => setIsNewRequestOpen(true)}
        >
          {t('sidenav.newRequest')}
        </Button>
      )}

      <Menu mode='inline'>
        {renderHomeTree(!!profile).map((menu, index) => (
          <React.Fragment key={index}>
            {Array.isArray(menu.submenu) ? (
              <React.Fragment key={`submenu-${menu.key}`}>
                <Menu.SubMenu
                  className={menu?.auth && !profile ? 'hidden' : ''}
                  key={menu.key}
                  icon={
                    router.asPath.split('/')[1].includes(menu.path)
                      ? menu.iconActive
                      : menu.icon
                  }
                  title={t(menu.title)}
                >
                  {menu.submenu.map((subMenu) => {
                    return (
                      <Menu.Item
                        key={subMenu.key}
                        className={`${
                          router.asPath.split('?')[0] === getMenuHref(subMenu.path)
                            ? 'active'
                            : ''
                        }`}
                        onClick={() => setOpen(false)}
                      >
                        {t(subMenu.title)}
                        <Link href={getMenuHref(subMenu.path)} />
                      </Menu.Item>
                    )
                  })}
                </Menu.SubMenu>
              </React.Fragment>
            ) : (
              <Menu.Item
                key={menu.key}
                icon={
                  router.pathname.split('/')[2] === menu.path
                    ? menu.iconActive
                    : menu.icon
                }
                className={`${
                  router.asPath.split('?')[0] === getMenuHref(menu.path)
                    ? 'active'
                    : ''
                } ${menu?.auth && !profile ? '!hidden' : ''}`}
                onClick={() => setOpen(false)}
              >
                {t(menu.title)}
                <Link href={getMenuHref(menu.path)} />
              </Menu.Item>
            )}
          </React.Fragment>
        ))}

        {profile && <Divider className='my-0 border-[#48688B]' />}

        {profile && (
          <Menu.Item
            key='logout'
            icon={<Logout />}
            onClick={() => {
              dispatch(logout())
              router.push('/')
            }}
          >
            Esci
          </Menu.Item>
        )}
      </Menu>

      {!profile && (
        <div className='mx-28 mt-24'>
          <Row gutter={[8, 16]}>
            <Col span={24}>
              <Button
                className='btn-green h-auto w-full text-sm font-medium rounded-lg py-16 mr-20'
                onClick={() => setLoginOpen(true)}
              >
                Login
              </Button>
            </Col>
            <Col span={24}>
              <Button
                className='btn-green-outlined !bg-transparent h-auto w-full text-sm font-medium rounded-lg py-16'
                onClick={() => setRegisterOpen(true)}
              >
                Registrati
              </Button>
            </Col>
          </Row>
        </div>
      )}

      {profile ? (
        <NeedHelp open={isNeedHelpOpen} setOpen={setIsNeedHelpOpen} />
      ) : (
        <></>
      )}

      <Register open={registerOpen} setOpen={setRegisterOpen} />
      <Login open={loginOpen} setOpen={setLoginOpen} />
      <NewRequest open={isNewRequestOpen} setOpen={setIsNewRequestOpen} />
    </>
  )
}
